module.exports = __webpack_public_path__ + "static/media/girl.e34d19f3.svg";